{
  "organization.title": "Organization",
  "onboarding.title": "Add client",
  "onboarding.create": "Create client and invite owner",
  "onboarding.created": "Client created",
  "onboarding.invited": "Invitation queued for {email}.",
  "onboarding.slug": "Organization code",
  "onboarding.slug_hint": "Lowercase letters and hyphens. The code stays fixed.",
  "onboarding.locale": "Base language",
  "onboarding.plan": "Plan",
  "onboarding.owner": "Invite owner",
  "onboarding.demo": "Demo organization with fictional data",
  "onboarding.website_separate": "The website receives its own design and is set up separately. After accepting the invitation, the owner can manage properties, contacts and the team.",
  "organization.name": "Agency name",
  "organization.legal_name": "Legal name",
  "organization.timezone": "Time zone",
  "organization.registrations": "Registrations",
  "organization.registration_label": "Registration type",
  "organization.registration_value": "Number or reference",
  "organization.registration_add": "Add registration",
  "organization.registration_remove": "Remove registration {label}",
  "organization.publish_required": "Publish the website again to show public changes.",
  "organization.areas.title": "Areas",
  "organization.areas.name": "Name",
  "organization.areas.add_name": "Add name in language",
  "organization.areas.remove_name": "Remove name in {locale}",
  "organization.areas.kind": "Area type",
  "organization.areas.parent": "Parent area",
  "organization.areas.no_parent": "No parent area",
  "organization.areas.new": "Add area",
  "organization.areas.edit": "Edit area",
  "organization.areas.edit_named": "Edit {name}",
  "organization.areas.remove_named": "Remove {name}",
  "organization.areas.empty": "No areas recorded",
  "organization.areas.slug": "Area code",
  "organization.areas.slug_hint": "Lowercase letters and hyphens. The code stays fixed after creation.",
  "organization.areas.aliases": "Other names",
  "organization.areas.aliases_hint": "Separate multiple names with a comma.",
  "organization.areas.remove_title": "Remove area?",
  "organization.areas.remove_body": "You are removing {slug}. An area still in use cannot be removed.",
  "organization.areas.removed": "Area removed",
  "organization.area_kind.island": "Island",
  "organization.area_kind.region": "Region",
  "organization.area_kind.municipality": "Municipality",
  "organization.area_kind.locality": "Locality",
  "organization.area_kind.district": "District"
}
